import { filter, Observable, OperatorFunction } from 'rxjs';

export function isDefined<T>(): OperatorFunction<T | null | undefined, NonNullable<T>> {
  return function (source$: Observable<T | null | undefined>): Observable<NonNullable<T>> {
    return source$.pipe(filter((v: T | null | undefined): v is NonNullable<T> => v !== null && v !== undefined));
  };
}

export function isDefinedCombine<T>(): OperatorFunction<(T | null | undefined)[], NonNullable<T>[]> {
  return function (source$: Observable<(T | null | undefined)[]>): Observable<NonNullable<T>[]> {
    return source$.pipe(
      filter((values: (T | null | undefined)[]): values is NonNullable<T>[] =>
        values.every((v: T | null | undefined): v is NonNullable<T> => v !== null && v !== undefined),
      ),
    );
  };
}
